import apiClient from './apiClient';
import ExamstragglesDataStore from '@/data/datastores/ExamstragglesDataStore';
import { examstraggles as schemaExamstraggles } from './schemas';

class ExamstragglesDataStoreGraphQL implements ExamstragglesDataStore {
  client = apiClient();

  async getLateCourses(career: string, period: string) {
    try {
      const response = await this.client.query({
        query: schemaExamstraggles.getLateCourses,
        variables: { career, period }
      });
      const { data } = response;
      return data.LateCourses;
    } catch (error) {
      throw new Error('Error "getLateCourses"');
    }
  }

  async registerLateCourses(request: any) {
    try {
      const response = await this.client.mutate({
        mutation: schemaExamstraggles.registerLateCourses,
        variables: {
          procedureId: request.procedureId,
          courseCatalog: request.courseCatalog,
          courseId: request.courseId,
          period: request.period,
          assessmentType: request.assessmentType,
          assessmentTypeDesc: request.assessmentTypeDesc,
          courseDescription: request.courseDescription,
          requirePayment: request.requirePayment,
          numberClass: request.numberClass,
          turn: request.turn,
          startDate: request.startDate
        }
      });
      const { data } = response;
      return {
        requestId: data?.registerLateCourses?.requestId,
        error: data?.registerLateCourses.error
      };
    } catch (error) {
      throw new Error('Error registerReincorporation');
    }
  }

  async activatePaymentLateCourses(requestId: number) {
    try {
      const response = await this.client.mutate({
        mutation: schemaExamstraggles.activatePaymentLateCourses,
        variables: {
          requestId
        }
      });
      const { data } = response;
      return {
        requestId: data?.activatePaymentLateCourses?.requestId,
        error: data?.activatePaymentLateCourses.error
      };
    } catch (error) {
      throw new Error('Error activatePaymentLateCourses');
    }
  }
}
export default ExamstragglesDataStoreGraphQL;
